var map = {
	"./archive": "elzb",
	"./archive/": "elzb",
	"./archive/index": "elzb",
	"./archive/index.js": "elzb",
	"./single_article": "/yI4",
	"./single_article/": "/yI4",
	"./single_article/index": "/yI4",
	"./single_article/index.js": "/yI4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uAWr";